'use client';

import LateralDrawer from '@/components/common/LateralDrawer';
import PageTitle from '@/components/common/pageTitle';
import TextButton from '@/components/common/TextButton';
import NewSpecificAllocation from '@/components/specificAllocation/NewSpecificAllocation';
import SpecificAllocationTable from '@/components/specificAllocation/SpecificAllocationTable';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function SpecificAllocation() {
  const { t } = useTranslation(['specificAllocation', 'common']);
  const [drawerStatus, setDrawerStatus] = useState(false);
  const [selectedAllocation, setSelectedAllocation] = useState<string | null>(null);

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mr: 2,
      }}
    >
      <PageTitle
        title={t('specific.allocation')}
        titleLabel={` (${t('common:collaborator')})`}
        subtitle={`${t('specific.allocation.subtitle')}`}
      />

      <Box
        sx={{
          display: 'flex',
          mb: 2,
          alignItems: 'center',
        }}
      >
        <TextButton
          sx={{ ml: 'auto' }}
          text={`+ ${t('new.allocation')}`}
          onClick={() => {
            setSelectedAllocation(null);
            setDrawerStatus(true);
          }}
        />
      </Box>

      <SpecificAllocationTable
        setOpenEdit={setDrawerStatus}
        selectedAllocation={selectedAllocation}
        setSelectedAllocation={setSelectedAllocation}
      />

      <LateralDrawer open={drawerStatus} setOpen={setDrawerStatus} position="right" size="bigger">
        <NewSpecificAllocation
          setSelectedAllocation={setSelectedAllocation}
          selectedAllocation={selectedAllocation}
          setDrawerOpen={setDrawerStatus}
        />
      </LateralDrawer>
    </Box>
  );
}

export default SpecificAllocation;
